import { render, staticRenderFns } from "./BaseKinostart.vue?vue&type=template&id=79b64971&"
import script from "./BaseKinostart.vue?vue&type=script&lang=js&"
export * from "./BaseKinostart.vue?vue&type=script&lang=js&"
import style0 from "./BaseKinostart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports